import { Card, FormField, Input } from "@rothoblaas/design-system";
import { FC } from "react";
import { useAuthContext } from "../../context/authContext";
import useI18n from "../../hooks/useTranslations";
import { User } from "../../http/types/users";
import { getUILanguages } from "../../types";
import { formatUtcDay } from "../../utils";
import FormFieldsContainer from "../ui/FormFieldsContainer";
import styles from "./AdminUser.module.css";

// Read only: name and email are synced from the SSO at each login, the language comes from it.
const AdminUserGeneralData: FC<{ user?: User }> = ({ user }) => {
  const i18n = useI18n();
  const auth = useAuthContext();

  const language = getUILanguages(i18n.translation).find((x) => x.value == user?.language);

  return (
    <Card shadow>
      <FormFieldsContainer fullWidth>
        <div className={styles.fieldsLayout}>
          <div className={styles.mainFields}>
            <FormField label={i18n.translation.common.name} isOptional>
              {({ labelId }) => <Input id={labelId} value={user?.firstName ?? ""} disabled readOnly />}
            </FormField>
            <FormField label={i18n.translation.common.lastName} isOptional>
              {({ labelId }) => <Input id={labelId} value={user?.lastName ?? ""} disabled readOnly />}
            </FormField>
            <FormField label={i18n.translation.common.email} isOptional>
              {({ labelId }) => <Input id={labelId} value={user?.email ?? ""} disabled readOnly />}
            </FormField>
          </div>
          <div className={styles.sideFields}>
            <FormField label={i18n.translation.common.languages.singular} isOptional>
              {({ labelId }) => <Input id={labelId} value={language?.display ?? ""} disabled readOnly />}
            </FormField>
            <FormField label={i18n.translation.common.lastAccess} isOptional>
              {({ labelId }) => (
                <Input
                  id={labelId}
                  value={user?.lastAccess ? formatUtcDay(user.lastAccess, auth.identity?.language) : ""}
                  disabled
                  readOnly
                />
              )}
            </FormField>
          </div>
        </div>
      </FormFieldsContainer>
    </Card>
  );
};

export default AdminUserGeneralData;
